import React, { useState } from "react";
import { Box, Flex, VStack, Button, Heading, Text, useColorModeValue as mode } from "@chakra-ui/react";
import SetupCheckLists from "./setup/SetupCheckLists";
import SetupMissedCallMessage from "./setup/SetupMissedCallMessage";
import SetupGeneral from "./setup/SetupGeneral";

const Setup = () => {
  const [selectedCategory, setSelectedCategory] = useState("general");

  const categories = [
    { id: "general", name: "General Setup", component: <SetupGeneral /> },
    { id: "checklists", name: "Checklist Setup", component: <SetupCheckLists /> },
    { id: "missed-call", name: "Missed Call Message", component: <SetupMissedCallMessage /> },
  ];

  const selectedCategoryData = categories.find((cat) => cat.id === selectedCategory);

  return (
    <Flex direction={{ base: "column", md: "row" }} h={{ base: "auto", md: "calc(100vh - 64px)" }} overflow='hidden'>
      {/* Left Navigation */}
      <Box
        w={{ base: "100%", md: "250px" }}
        bg={mode("gray.100", "gray.800")}
        borderRight={{ base: "none", md: "1px" }}
        borderBottom={{ base: "1px", md: "none" }}
        borderColor={mode("gray.200", "gray.700")}
        p={4}
      >
        <VStack
          spacing={2}
          align='stretch'
          direction={{ base: "row", md: "column" }}
          flexWrap={{ base: "wrap", md: "nowrap" }}
        >
          {categories.map((category) => (
            <Button
              key={category.id}
              variant={selectedCategory === category.id ? "solid" : "ghost"}
              colorScheme={selectedCategory === category.id ? "blue" : "gray"}
              justifyContent={{ base: "center", md: "flex-start" }}
              flex={{ base: "1 1 auto", md: "1" }}
              minW={{ base: "120px", md: "auto" }}
              onClick={() => setSelectedCategory(category.id)}
              minH='40px'
            >
              {category.name}
            </Button>
          ))}
        </VStack>
      </Box>

      {/* Main Content */}
      <Box flex='1' overflow='auto'>
        {selectedCategoryData?.component || (
          <Box p={{ base: 4, md: 8 }}>
            <Heading size='lg' mb={4}>
              {selectedCategoryData?.name}
            </Heading>
            <Text color={mode("gray.600", "gray.400")}>This section is under construction.</Text>
          </Box>
        )}
      </Box>
    </Flex>
  );
};

export default Setup;
